import coreServices from "../secrets-web/src/services/core";
import workspaceServices from "../secrets-web/src/services/workspace";
import projectServices from "../secrets-web/src/services/project";
import syncServices from "../secrets-web/src/services/sync";

import userServices from "./user";
import storeActions from "../store/actions";

import global from "../config/global";
import common from "../secrets-web/src/services/common";

async function update_auth_info(data) {
  userServices.update_account_info({
    username: data.username,
    full_name: data.full_name,
  })
  await coreServices.unlock({
    username: data.username || data.email,
    password: data.password,
    ...data
  })
}

async function sync_profile() {
  const { profile } = await syncServices.sync_profile_data();
  const prelogin = await userServices.get_prelogin();
  const accountInfo = await userServices.get_account();
  const userInfo = global.store.getState().auth.userInfo;
  global.store.dispatch(storeActions.updateUserInfo({
    ...userInfo,
    ...accountInfo,
    ...prelogin,
    ...profile,
  }));
  await global.jsCore.syncService.syncProfile({
    key: profile?.key,
    privateKey: profile?.privateKey,
    organizations: profile?.projects,
    securityStamp: profile?.securityStamp || null,
    emailVerified: profile?.emailVerified || false
  })
}

async function sync_data(payload = { isDelete: false, wsId: null, returnRouter: null }) {
  const { isDelete = false, wsId = null, returnRouter = null } = payload;
  const requests = [
    workspaceServices.list({ paging: 0 }),
  ]

  await Promise.all(requests).then(async ([
    workspaces,
  ]) => {
    if (workspaces.length === 0) {
      global.store.dispatch(storeActions.updateSelectedWorkspace(null));
      global.navigate("CREATE_WORKSPACE");
    } else {
      const workspaceId = wsId || returnRouter?.params?.workspace_id || null;
      const projectId = returnRouter?.params?.project_id || null;
      if (workspaceId && !!workspaces.find((w) => w.id == workspaceId)) {
        global.store.dispatch(storeActions.updateSelectedWorkspace(workspaces.find((w) => w.id === workspaceId)));
        const projects = await projectServices.list({ paging: 0, organization_id: workspaceId });
        global.store.dispatch(storeActions.updateProjects(projects));
        if (returnRouter && (!projectId || !!projects.find((p) => p.id == projectId))) {
          global.navigate(returnRouter.name, returnRouter.params, returnRouter.query);
        } else {
          global.navigate("PROJECTS", { workspace_id: workspaceId });
        }
      } else {
        const projects = await projectServices.list({ paging: 0, organization_id: workspaces[0]?.id });
        global.store.dispatch(storeActions.updateSelectedWorkspace(workspaces[0]));
        global.store.dispatch(storeActions.updateProjects(projects));
        global.navigate("PROJECTS", { workspace_id: workspaces[0].id });
      }
      if (isDelete) {
        setTimeout(() => {
          global.store.dispatch(storeActions.updateWorkspaces(workspaces));
        }, 1000);
      } else {
        global.store.dispatch(storeActions.updateWorkspaces(workspaces));
      }
    }
  })
}

common.sync_profile = sync_profile;

export default {
  ...common,
  update_auth_info,
  sync_data,
}